import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  componenetTable: {
    position: 'relative',
  },
  // Define some basic styles for the table
  pagination: {
    height: '120px',
    margin: '30px 0 5px',
    '@media(min-width: 800px)': {
      height: '40px',
    },
  },
  tableBlocK: {
    overflowY: 'auto',
    padding: ' 0 3px',
    '&::-webkit-scrollbar': {
      height: '5px',
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: '#091757',
    },

    '&::-webkit-scrollbar-thumb': {
      boxShadow: 'inset 0 0 6px #ccc',
      backgroundColor: '#fff',
    },
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0px 0px 0px 1px #dfdfdf!important',
    padding: '10px',
    margin: '15px 0 10px',
    position: 'relative',
  },

  tableLoading: {
    width: '100%',
    borderCollapse: 'collapse',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0px 0px 0px 1px #dfdfdf!important',
    padding: '10px',
    margin: '15px 0 10px',
    position: 'relative',
    height: '450px',
  },
  emptyHead: {
    height: '50px',
    minHeight: '50px',
    width: '100%',
    '& tr': {
      height: '50px',
      width: '100%',
      display: 'table',
    },
    '@media(max-width: 550px)': {
      display: 'none',
    },
  },
  th: {
    textAlign: 'center',
    backgroundColor: 'rgba(60, 76, 167, 0.03)',
    padding: '10px ',
    fontSize: '13px',
    height: '50px',
    color: '#303d8f',
    '@media(max-width: 800px)': {
      minWidth: '135px',
    },
    '&:first-child': {
      paddingLeft: '10px',
      '@media(max-width: 800px)': {
        minWidth: '40px',
      },
    },
    '&:last-child': { paddingRight: '20px' },
    '& img': {
      marginRight: '5px',
      position: 'relative',
      transform: 'rotate(0deg) translate(0, 0)',
      transitionDuration: '200ms',
    },
    '&.operation': { width: '132px' },
    '&.operationFull': { width: '190px' },
    '&.operationSmall': { width: '72px', textAlign: 'center' },
    '&.num': { width: '60px' },
  },

  desc: {
    textAlign: 'center',
    backgroundColor: 'rgba(60, 76, 167, 0.03)',
    padding: '10px ',
    fontSize: '13px',
    height: '50px',
    color: '#303d8f',
    '& img': {
      marginRight: '5px',
      position: 'relative',
      transform: 'rotate(180deg) translate(0, 0)',
      transitionDuration: '200ms',
    },
    '&.operation': { width: '132px' },
    '&.operationFull': { width: '190px' },
    '&.operationSmall': { width: '72px', textAlign: 'center' },
    '&.num': { width: '60px' },
  },

  td: {
    padding: ' 10px ',
    fontSize: '13px',
    height: '50px',
    color: '#2a2a2a',
    textAlign: 'center',
    '&:last-child': { paddingRight: '10px', direction: 'ltr' },
    '&.operation': { width: '132px' },
    '&.operationFull': { width: '190px' },
    '&.operationSmall': { width: '72px', textAlign: 'center' },
    '&.num': {
      width: '60px',
      fontSize: '14px',
      color: '#2b3990',
    },
  },
  tr: {
    ':nth-child(even)': { backgroundColor: '#f9f9f9' },
    borderTop: '1px solid  rgba(48, 61, 143, 0.1)',
  },
  updatedRow: {
    '& td': {
      animation: '$updatedRowBackground 1800ms ease-out',
    },
  },
  '@keyframes updatedRowBackground': {
    '0%': {
      backgroundColor: '#3d4ca7c9',
    },
    '100%': {
      backgroundColor: 'rgba(61, 76, 167, 0)',
    },
  },

  emptyLoading: {
    padding: ' 20px ',
    height: '450px',
    minHeight: '450px',
    display: 'table',
  },
  notFoundBlock: {
    padding: ' 20px ',
    height: '200px',
  },
  notFound: {
    position: 'absolute',
    right: '50%',
    top: '50%',
    transform: 'translate(50%, -25%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    '& icon': { width: '150px', height: '150px' },
    '& p': { color: '#303d8f', fontWeight: '600' },
    '@media(max-width: 800px)': {
      transform: 'translate(50%, -50%)',
    },
  },
  thead: {
    padding: '0 20px',
    '& tr': {
      borderTop: '0px',
    },
  },
  tbody: {
    padding: '0 20px',
    '& tr': {
      '&:hover': {
        background: '#f3f5ff',
      },
    },
  },
  actionCheckbox: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '15px',
    padding: '0 1px',
    height: '41px',
    justifyContent: 'space-between',
  },
  selectRow: {
    color: '#2b3990',
    fontWeight: '900',
    background: '#f9f9fc',
    fontSize: '12px',
    padding: '8px 15px',
  },
}));
